<template>
    <div>
        <!--<el-header :style="{'z-index': hideHeadShadow ? 999: 0}">
            <el-row style="width: 1000px;margin: 0 auto" type="flex" justify="space-between">
                <el-col :span="3">
                    <el-button type="primary" icon="el-icon-document" size="medium" circle></el-button>
                    <span style="font-size: 18px;color: #606266;font-weight: bolder;margin-left: 10px">资讯中心</span>
                </el-col>
                <el-col :span="10">
                    <el-input size="small" placeholder="搜索感兴趣的知识和文章" v-model="searchVal" clearable>
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                </el-col>
            </el-row>
        </el-header>-->
        <el-container>
            <section-list :sectionList="sectionList" @handleSelect="handleSelect" ref="sectionList" v-if="!queryTitle"></section-list>
            <el-main v-loading="loading">
                <el-row v-for="(information, index) in informationList" :key="information.id">
                    <el-col class="item-col" style="margin-left: 10px">
                        <el-row>
                            <el-col>
                                <el-link class="item-col-title" @click="openItem(information.id)"><i>•</i>{{information.title}}</el-link>
                            </el-col>
                        </el-row>
                        <el-row class="item-col-content" type="flex" align="middle">
                            <el-col :span="3">
                                <span><i class="el-icon-view"></i>{{information.readCount}}</span>
                            </el-col>
                            <el-col :span="4">
                                {{information.createdBy}}
                            </el-col>
                            <el-col :span="10" :offset="1">
                                <span v-if="information.tag">
                                    <el-tag type="warning" size="medium" v-for="(item, index) in information.tag.split(',')" :key="index">{{item}}</el-tag>
                                </span>
                            </el-col>
                            <el-col :span="5" :push="1">
                                {{information.createdTime}}
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col>
                        <el-divider></el-divider>
                    </el-col>
                </el-row>
                <!--缺省-->
                <div v-if="informationList.length === 0" style="text-align: center;margin-top: 50px">
                    <img src="@/assets/img/none.png" alt="" width="240" height="240">
                </div>
                <!--分页-->
                <div v-if="informationList.length > 0" style="text-align: center;margin-top: 20px;">
                    <el-pagination
                            background
                            layout="prev, pager, next, total"
                            :total="pageInfo.totalRecordCount"
                            :page-size.sync="pageInfo.pageSize"
                            :current-page.sync="pageInfo.pageNo"
                            @current-change="getInfoList">
                    </el-pagination>
                </div>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    // import throttle from 'throttle-debounce/throttle';
    const SectionList = () => import('@/components/section/SectionList');

    export default {
        name: "Information",
        components: {
            SectionList
        },
        data() {
            return {
                sectionList: [],
                informationList: [],
                currentSectionId: '',
                queryTitle: '',
                pageInfo: {
                    totalRecordCount: 0,
                    pageSize: 10,
                    pageNo: 1
                },
                loading: false,
                // el: null,
                // hideHeadShadow: true
            }
        },
        methods: {
            async getSectionAndInfoList() {
                this.queryTitle = this.$route.query.title;
                if (!this.queryTitle) {
                    const { content } = await this.$http.get('/system/web/code/getByCodeType', { params: { codeType: 'INFORMATION' } });
                    if (content) {
                        this.sectionList = content;
                        const codeNum = this.sectionList[0].codeNum;
                        this.currentSectionId = codeNum;
                        setTimeout(() => {
                            this.$refs.sectionList.defaultChoose = codeNum;
                        }, 100);
                    }
                }
                this.getInfoList(1);
            },
            async getInfoList(pageNo) {
                this.loading = true;
                const params = {
                    // page: pageNo && (this.pageInfo.pageNo = pageNo) ? pageNo : this.pageInfo.pageNo,
                    page: pageNo ? pageNo : this.pageInfo.pageNo,
                    size: this.pageInfo.pageSize,
                    sectionId: this.currentSectionId,
                    title: this.queryTitle,
                };
                const { content: { records, total } } = await this.$http.post('/business/web/information/list', params);
                this.informationList = records;
                this.pageInfo.totalRecordCount = total;
                this.loading = false;
            },
            handleSelect(index, indexPath) {
                this.currentSectionId = index;
                this.getInfoList(1);
            },
            openItem(id) {
                let path = this.$router.resolve({ path: '/home/article', query: {id: id} });
                window.open(path.href, '_blank');
            },
            /*onScroll() {
                const scrollHeight = this.el.scrollTop;
                this.hideHeadShadow = scrollHeight === 0;
            }*/
        },
        mounted() {
            // this.el = document.documentElement;
            // document.addEventListener('scroll', throttle(250, this.onScroll));
            this.getSectionAndInfoList();
        },
        watch: {
            // 监听页头传搜索值
            $route: function () {
                this.getSectionAndInfoList();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-container {
        width: 1000px;
        margin: 35px auto 0 auto;
    }

    .el-header {
        position:relative;
        width: 100%;
        height: 55px !important;
        line-height: 52px;
        background-color: white;
        border-top: 1px solid #EBEEF5;
        box-shadow: 0 4px 10px 0 hsla(240,3%,61%,.2);
    }

    .el-main {
        position: relative;
        margin: 0 0 50px 15px;
        //min-height: 850px;
        border: 1px solid #EBEEF5;
        border-radius: 6px;
        box-shadow: 0 1px 7px rgba(0, 0, 0, .12);
    }

    .item-col {
        margin-left: 12px;
    }

    .item-col-title {
        font-size: 16px;
        font-weight: bold;
    }

    .item-col-content {
        font-size: 14px;
        margin-top: 20px;
        color: #909399
    }

    .el-divider {
        margin: 8px 0 10px 0;
    }

    i {
        margin-right: 7px ;
    }

    .el-tag {
        margin-right: 7px;
    }
    >>> .el-loading-mask{
        z-index: 900 !important;
    }
</style>
